(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ErrorPageController', ErrorPageController);

  /** @ngInject */
  function ErrorPageController($scope, ErrorPageViewModel, errorActions, applicationStore) {
    var vm = this;

    vm.error = new ErrorPageViewModel();

    init ();

    function init () {
      // listen for message from dispatcher
      showErrorMsg(applicationStore.get().errorPageMsg);
      // applicationStore.on(applicationStore.events.ERROR_PAGE_STATE_CHANGE, showErrorMsg);

      $scope.$on('$destroy', function () {
        vm.error.destroy();
      });
    }

    function showErrorMsg(errText){
      vm.error.errorMessage = errText;
    }

    vm.goBack = function(){
      errorActions.acknowledgeAndGoBack();
    };

  }
})();
